<template>
  <div class="entity-selectors">
    <div class="form-group">
      <label class="form-label">{{ $t('messages.agency') }}</label>
      <div class="entity-row">
        <select class="form-select select-left" v-model="selectedAgency">
          <option :value="null">{{ $t('messages.select_agency') }}</option>
          <option v-for="a in agencies" :key="a.id" :value="a.id">{{ a.name }}</option>
        </select>
        <div class="search-input" style="display:flex; flex:1;">
          <input class="form-input" v-model="agencyQuery" :placeholder="$t('messages.enter_name')" />
        </div>
        <button class="btn-secondary" @click="createAgency" :disabled="!agencyQuery">{{ $t('messages.create')
          }}</button>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">{{ $t('messages.advertiser') }}</label>
      <div class="entity-row">
        <select class="form-select select-left" v-model="selectedAdvertiser">
          <option :value="null">{{ $t('messages.select_advertiser') }}</option>
          <option v-for="p in advertisers" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
        <div class="search-input" style="display:flex; flex:1;">
          <input class="form-input" v-model="advertiserQuery" :placeholder="$t('messages.enter_name')" />
        </div>
        <button class="btn-secondary" @click="createAdvertiser" :disabled="!advertiserQuery">{{ $t('messages.create')
        }}</button>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">{{ $t('messages.advertiser_category') }}</label>
      <div class="entity-row">
        <select class="form-select select-left" v-model="selectedCategory">
          <option :value="null">{{ $t('messages.select_advertiser_category') }}</option>
          <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name_ru || c.name_en }}</option>
        </select>
        <!-- creation removed: only selection allowed -->
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">{{ $t('messages.product') }}</label>
      <div class="entity-row">
        <select class="form-select select-left" v-model="selectedProduct">
          <option :value="null">{{ $t('messages.select_product') }}</option>
          <option v-for="pr in products" :key="pr.id" :value="pr.id">{{ pr.name }}</option>
        </select>
        <div class="search-input" style="display:flex; flex:1;">
          <input class="form-input" v-model="productQuery" :placeholder="$t('messages.enter_name')" />
        </div>
        <button class="btn-secondary" @click="createProduct" :disabled="!productQuery || !selectedAdvertiser">{{
          $t('messages.create') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntitySelectors",
  props: {
    value: { type: Object, default: () => ({}) }, // { product_id }
    agencies: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    advertisers: { type: Array, default: () => [] },
    products: { type: Array, default: () => [] }
  },
  data() {
    return {
      agencyQuery: '',
      selectedAgency: null,

      advertiserQuery: '',
      selectedAdvertiser: null,

      selectedCategory: null,

      productQuery: '',
      selectedProduct: this.value.product_id || null,
    };
  },
  mounted() {
    // initialize selections from value if present
    this.selectedProduct = this.value.product_id || null;
    this.selectedAgency = this.value.agency_id || null;
    this.selectedAdvertiser = this.value.advertiser_id || null;
    this.selectedCategory = this.value.advertiser_category_id || null;
  },

  methods: {
    async createAgency() {
      const res = await fetch('/api/agencies', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': document.querySelector('meta[name=\"csrf-token\"]').getAttribute('content') }, body: JSON.stringify({ name: this.agencyQuery }) });
      const item = await res.json();
      this.$emit('created', { type: 'agency', item });
      this.selectedAgency = item.id;
      this.agencyQuery = '';
    },
    async createAdvertiser() {
      const payload = { name: this.advertiserQuery };
      const res = await fetch('/api/advertisers', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': document.querySelector('meta[name=\"csrf-token\"]').getAttribute('content') }, body: JSON.stringify(payload) });
      const item = await res.json();
      this.$emit('created', { type: 'advertiser', item });
      this.selectedAdvertiser = item.id;
      this.advertiserQuery = '';
    },
    async createProduct() {
      const payload = { name: this.productQuery };
      const res = await fetch('/api/products', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': document.querySelector('meta[name=\"csrf-token\"]').getAttribute('content') }, body: JSON.stringify(payload) });
      const item = await res.json();
      this.$emit('created', { type: 'product', item });
      this.selectedProduct = item.id;
      this.productQuery = '';
      this.emitValue();
    },
    emitValue() {
      this.$emit('update', {
        product_id: this.selectedProduct,
        advertiser_id: this.selectedAdvertiser,
        agency_id: this.selectedAgency,
        advertiser_category_id: this.selectedCategory
      });
    }
  },
  watch: {
    selectedProduct() {
      this.emitValue();
    },
    selectedAgency() {
      this.emitValue();
    },
    selectedAdvertiser() {
      this.emitValue();
    },
    selectedCategory() {
      this.emitValue();
    },
    value(val) {
      // sync all selections when parent value changes to avoid unexpected resets
      this.selectedProduct = val.product_id || null;
      this.selectedAgency = val.agency_id || null;
      this.selectedAdvertiser = val.advertiser_id || null;
      this.selectedCategory = val.advertiser_category_id || null;
    }
  }
};
</script>

<style scoped>
.inline-control {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.form-group {
  margin-bottom: 12px;
}

.entity-row {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.select-left {
  width: 50% !important;
}

.control-right {
  display: flex;
  flex: 1;
  gap: 8px;
  align-items: center;
}
</style>
